<template>
  <el-popover
    v-bind="$attrs"
    :width="width"
    :placement="placement"
    class="f360-tooltip-base"
    :disabled="!tooltip"
    :popper-class="popperClass"
  >
    <template #reference>
      <slot name="default" />
    </template>

    <div class="f360-tooltip-base__wrapper">
      <p class="f360-tooltip-base__label" v-html="sanitizeHtml(tooltip)"></p>
    </div>
  </el-popover>
</template>

<script setup lang="ts">
import { Placement } from "element-plus";
import { computed } from "vue";
import { sanitizeHtml } from "@/core/common/sanitizeHtml";

defineEmits<{
  (e: "onClick"): void;
}>();

const props = withDefaults(
  defineProps<{
    tooltip?: string;
    width?: number;
    placement?: Placement;
    redirectLabel?: string;
    redirectTo?: string;
    type?: "default" | "primary" | "danger" | "warning" | "info";
  }>(),
  {
    width: 200,
    placement: "top",
    type: "default"
  }
);

const popperClass = computed(() => ({
  "f360-tooltip-base__popper": true,
  "f360-tooltip-base__popper--type-default": props.type === "default",
  "f360-tooltip-base__popper--type-primary": props.type === "primary",
  "f360-tooltip-base__popper--type-danger": props.type === "danger",
  "f360-tooltip-base__popper--type-warning": props.type === "warning",
  "f360-tooltip-base__popper--type-info": props.type === "info"
}));
</script>

<style lang="scss">
@use "@/ui/styles/variables" as *;
@use "@/ui/styles/theme/f360-theme" as *;

.f360-tooltip-base {
  &__popper {
    &--type-default {
      border-bottom: none;
    }
    &--type-primary {
      border-bottom: 2px solid _map.get($azulPrincipal, 700) !important;
    }
    &--type-danger {
      border-bottom: 2px solid _map.get($vermelho, 700) !important;
    }
    &--type-warning {
      border-bottom: 2px solid _map.get($amarelo, 700) !important;
    }
    &--type-info {
      border-bottom: 2px solid _map.get($neutro, 700) !important;
    }
  }

  &__wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &__label {
    margin: 0;
    font-family: $fontFamily;
    color: $font-color;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    word-break: normal;
    text-align: left;
  }

  &__footer {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__link {
    cursor: pointer;
    width: fit-content;
    display: flex;
    align-items: center;
    gap: 8px;
    text-decoration: none;
    font-family: $fontFamily;
    color: $font-color-f360;
    font-size: 10px;
    line-height: 14px;
    font-weight: 400;
  }

  &__icon {
    color: $font-color-f360;
    font-size: 16px;
  }
}
</style>
